export * from './src/app/datagrid/ng-datagrid.model';
export * from './src/app/datagrid/pagination.component';



// WEBPACK FOOTER //
// ./~/angular2-datagrid/index.ts